// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Container for the dropdown */
.dropdown-container {
    position: relative;
    display: inline-block;
  }
  
  /* Style for the dropdown button */

  
  /* Hidden menu by default */
  .dropdown-menu {
    display: none;
    position: absolute;
    top: 40px; /* Adjust based on your button size */
    left: 0;
    background-color: #d3d3d3; /* Grey background color */
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    margin: 0px 0; /* smaller gap between items */
    line-height: 1.35; /* denser lines */
  }
  
  /* Show the menu on hover */
  .dropdown-container:hover .dropdown-menu {
    display: block;
  }
  
  /* Style for the dropdown list */
  .dropdown-menu li {
    list-style-type: none;
    margin: 0px 0; /* smaller gap between items */
    line-height: 1.35; /* denser lines */
  }
  
  .dropdown-menu li a:hover {
    padding: 10px;
    cursor: pointer;
    font-size: 16px;
    background-color: #110d0d;
  }
  
  
  /* Highlight option when hovering over list items */
  .dropdown-menu li:hover {
    text-decoration: none;
    color: purple; /* White text color */
   /* background-color: #f6f0f0;*/
  }

  /* Style for the dropdown list (Horizontal alignment) */
.dropdown-menu a {
    list-style-type: none;
    padding: 0;
    margin: 0px 0; /* smaller gap between items */
    display: flex; /* Align items horizontally */
    flex-direction: row; /* Items will be displayed from left to right */
    justify-content: flex-start; /* Align items to the start (left) */
    gap: 15px; /* Optional: Add space between items */
  }
  
  /* Style for each list item */
  .dropdown-menu li {
    padding: 10px;
    cursor: pointer;
    font-size: 16px;
    color: purple;
    white-space: nowrap; /* Prevent text from wrapping if it's long */
  }

    /* Styling for each link */
    .dropdown-menu{
        text-decoration: none;
        color: purple; /* White text color */
        padding: 10px 20px; /* Adds padding around each link */
        margin: 0 15px; /* Adds space between the links */
        font-size: 14px;

      }

      /* hover color*/
      .dropdown-menu li a:hover {
        background-color: #110d0d;
      }`, "",{"version":3,"sources":["webpack://./src/AreaOfPractise.css"],"names":[],"mappings":";AACA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,kCAAkC;;;EAGlC,2BAA2B;EAC3B;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS,EAAE,qCAAqC;IAChD,OAAO;IACP,yBAAyB,EAAE,0BAA0B;IACrD,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa,EAAE,8BAA8B;IAC7C,iBAAiB,EAAE,iBAAiB;EACtC;;EAEA,2BAA2B;EAC3B;IACE,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE,qBAAqB;IACrB,aAAa,EAAE,8BAA8B;IAC7C,iBAAiB,EAAE,iBAAiB;EACtC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,yBAAyB;EAC3B;;;EAGA,mDAAmD;EACnD;IACE,qBAAqB;IACrB,aAAa,EAAE,qBAAqB;GACrC,8BAA8B;EAC/B;;EAEA,uDAAuD;AACzD;IACI,qBAAqB;IACrB,UAAU;IACV,aAAa,EAAE,8BAA8B;IAC7C,aAAa,EAAE,6BAA6B;IAC5C,mBAAmB,EAAE,+CAA+C;IACpE,2BAA2B,EAAE,oCAAoC;IACjE,SAAS,EAAE,sCAAsC;EACnD;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB,EAAE,4CAA4C;EACnE;;IAEE,0BAA0B;IAC1B;QACI,qBAAqB;QACrB,aAAa,EAAE,qBAAqB;QACpC,kBAAkB,EAAE,kCAAkC;QACtD,cAAc,EAAE,iCAAiC;QACjD,eAAe;;MAEjB;;MAEA,eAAe;MACf;QACE,yBAAyB;MAC3B","sourcesContent":["\n/* Container for the dropdown */\n.dropdown-container {\n    position: relative;\n    display: inline-block;\n  }\n  \n  /* Style for the dropdown button */\n\n  \n  /* Hidden menu by default */\n  .dropdown-menu {\n    display: none;\n    position: absolute;\n    top: 40px; /* Adjust based on your button size */\n    left: 0;\n    background-color: #d3d3d3; /* Grey background color */\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    margin: 0px 0; /* smaller gap between items */\n    line-height: 1.35; /* denser lines */\n  }\n  \n  /* Show the menu on hover */\n  .dropdown-container:hover .dropdown-menu {\n    display: block;\n  }\n  \n  /* Style for the dropdown list */\n  .dropdown-menu li {\n    list-style-type: none;\n    margin: 0px 0; /* smaller gap between items */\n    line-height: 1.35; /* denser lines */\n  }\n  \n  .dropdown-menu li a:hover {\n    padding: 10px;\n    cursor: pointer;\n    font-size: 16px;\n    background-color: #110d0d;\n  }\n  \n  \n  /* Highlight option when hovering over list items */\n  .dropdown-menu li:hover {\n    text-decoration: none;\n    color: purple; /* White text color */\n   /* background-color: #f6f0f0;*/\n  }\n\n  /* Style for the dropdown list (Horizontal alignment) */\n.dropdown-menu a {\n    list-style-type: none;\n    padding: 0;\n    margin: 0px 0; /* smaller gap between items */\n    display: flex; /* Align items horizontally */\n    flex-direction: row; /* Items will be displayed from left to right */\n    justify-content: flex-start; /* Align items to the start (left) */\n    gap: 15px; /* Optional: Add space between items */\n  }\n  \n  /* Style for each list item */\n  .dropdown-menu li {\n    padding: 10px;\n    cursor: pointer;\n    font-size: 16px;\n    color: purple;\n    white-space: nowrap; /* Prevent text from wrapping if it's long */\n  }\n\n    /* Styling for each link */\n    .dropdown-menu{\n        text-decoration: none;\n        color: purple; /* White text color */\n        padding: 10px 20px; /* Adds padding around each link */\n        margin: 0 15px; /* Adds space between the links */\n        font-size: 14px;\n\n      }\n\n      /* hover color*/\n      .dropdown-menu li a:hover {\n        background-color: #110d0d;\n      }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
